mutation DeleteContentsMutation($ids: [ID!]!) {
  deleteContents(ids: $ids) {
    id
  }
}
